import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppletLabelContainerModel } from '../../../../../../models/aggregates/applet/label';
import { BaseApiTemplateService, Core2Config } from '../../shared';

@Injectable({providedIn: 'root'})

export class AppletLabelService extends BaseApiTemplateService<AppletLabelContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-labels';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-labels';
    this.httpClient = http;
  }

}
